export const CONTENT_SELECTOR_OPTIONS = [
	{
		label: 'Select Visible Columns',
		options: [
			{ id: 'operationName', label: 'Operation Name', visible: true },
			{ id: 'version', label: 'Version', visible: true },
			{ id: 'description', label: 'Description', visible: true },
			{ id: 'status', label: 'Status', visible: true },
			{ id: 'integrationType', label: 'Integration Type', visible: true },
			{ id: 'idempotent', label: 'Idempotent', visible: false },
			{ id: 'createdBy', label: 'Created By', visible: false },
			{ id: 'lastUpdatedBy', label: 'Last Updated By', visible: false },
		],
	},
];

export const PAGE_SELECTOR_OPTIONS = [
	{ value: 10, label: '10 Operations' },
	{ value: 30, label: '30 Operations' },
	{ value: 50, label: '50 Operations' },
];

export const COLLECTION_PREFERENCES = {
	title: 'Preferences',
	confirmLabel: 'Confirm',
	cancelLabel: 'Cancel',
	pageSizePreference: {
		title: 'Select page size',
		options: PAGE_SELECTOR_OPTIONS,
	},
	visibleContentPreference: {
		title: 'Select visible content',
		options: CONTENT_SELECTOR_OPTIONS,
	},
};

export const DEFAULT_PREFERENCES = {
	pageSize: 10,
	visibleContent: [
		'operationName',
		'version',
		'description',
		'status',
		'integrationType',
		'actions',
	],
};
